import ProfileTopNavigation from './ProfileTopNavigation';
import LogutSection from '../../PageComponent/ProfilePage/logoutComponent';

function Logout() {
  return (
    <div className="text-coalBlack">
      <ProfileTopNavigation pageTitle={'Logout account'} />
      <LogutSection />
    </div>
  );
}

export default Logout;
